module.exports = __webpack_public_path__ + "static/media/9.e8715e67.jpeg";